export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string | undefined,
    message: string,
    /** The parsed error response body, when it was JSON. Lets callers read
     *  endpoint-specific fields the generic error shape doesn't model — e.g.
     *  the withdraw gate's `setup_account_url` / `link` on a 403. */
    public readonly data?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NetworkError extends Error {
  constructor(message = 'Network error') {
    super(message);
    this.name = 'NetworkError';
  }
}

export interface ApiRequestOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  signal?: AbortSignal;
  /** Extra per-request headers, merged on top of the default
   *  Content-Type + X-Platform-Session. Used by `instant_purchase` to
   *  attach the optional `X-Idempotency-Key`. */
  headers?: Record<string, string>;
  /** Send no `X-Platform-Session` even when a session exists. The free demo
   *  uses it: that endpoint is anonymous by design, and a token on the wire
   *  would quietly couple the two the day the backend starts reading it. */
  anonymous?: boolean;
}
